<script setup lang="ts">
import { Motion } from 'motion/vue'

const { defineOgMeta } = useSeoAttributes()
const {
  public: { baseUrl },
} = useRuntimeConfig()

const pageMeta = usePageMeta()

const { pending, data: meta } = await useAsyncData('contact', async () => pageMeta.fetchByPath('/contact'))

if (meta.value) {
  useHead(() => ({
    title: meta.value?.title!,
    link: [{ rel: 'canonical', href: `${baseUrl}/contact` }],
    meta: defineOgMeta({
      title: meta.value?.title!,
      description: meta.value?.description!,
      image: meta.value?.image,
    }),
  }))
}
</script>

<template>
  <Loader :pending="pending">
    <Container class="screen-content px-2">
      <LayoutPageHeader :title="$t('contact.title')">
        <template #description>
          {{ $t('contact.description') }}
        </template>
      </LayoutPageHeader>

      <div class="relative flex flex-col items-start md:flex-row">
        <div class="relative z-10 w-full lg:w-1/2">
          <Motion
            :initial="{ opacity: 0, y: 64 }"
            :animate="{ opacity: 1, y: 0 }"
            :transition="{ easing: [0.16, 1, 0.3, 1], duration: 1 }"
          >
            <ContactForm />
          </Motion>
          <Motion
            :initial="{ opacity: 0, y: 64 }"
            :animate="{ opacity: 1, y: 0 }"
            :transition="{ easing: [0.16, 1, 0.3, 1], duration: 1, delay: 0.1 }"
          >
            <ContactBusinessCard class="absolute bottom-4 sm:left-4 lg:bottom-20 lg:w-2/3 xl:w-2/3" />
          </Motion>
        </div>

        <div class="z-0 mt-4 w-full px-0 py-8 md:-ml-4 md:mt-0 md:px-0 lg:w-1/2">
          <Motion
            :initial="{ opacity: 0, y: 64 }"
            :animate="{ opacity: 1, y: 0 }"
            :transition="{ easing: [0.16, 1, 0.3, 1], duration: 1, delay: 0.2 }"
          >
            <ContactFaq class="bordershadow-gray rounded-lg bg-gray-50 px-4 py-8 md:pl-12 md:pr-8" />
          </Motion>
        </div>
      </div>
    </Container>
    <Container class="h-32"></Container>
  </Loader>
</template>
